import React, { useEffect, useState } from 'react';
import './BridalMakeup.css';
import { Link } from 'react-router-dom';
import Testimonial1 from '../../components/Testimonial1';
import { getCourseImages } from '../../services/galleryService';

const SelfMakeup = () => {
  const [images, setImages] = useState([]);
  const [current, setCurrent] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    getCourseImages().then(setImages);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images]);

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  return (
    <div className="bridal-page">
      <div className=" slide-up">
        <h1 className="page-title">Self Makeup Class</h1>
      </div>

      <div className="gallery-section">
        {images.length > 0 && <img src={images[current]} alt="main" className="main-image" />}
        <div className="thumbnail-strip">
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`thumb-${index}`}
              className={`thumbnail ${current === index ? 'active' : ''}`}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>

      <div className="buttons-container">
        {/* <button
          className="primary-btn"
          onClick={() => window.location.href = "/make-an-enquiry"}
        >
          Make an Enquiry
        </button> */}

        <button
          className="drawer-toggle-btn"
          onClick={toggleDrawer}
        >
          All You Need to Know About Self Makeup Class ▾
        </button>
      </div>

      {drawerOpen && (
        <div className="drawer-content">
          <p>In a world full of brunches, office meet-ups, weddings, and impromptu photo sessions — showing up confidently and looking effortlessly put together has become part of modern self-care.
            <br />And guess what? You don’t need to be a professional to master your own makeup — you just need the right guidance (and maybe a little blush magic). ✨</p>

          <h3>💁‍♀️ Why We Created This Self-Makeup Class:</h3>
          <p>We noticed so many people wanted to feel confident doing their own makeup — but either didn’t know where to start, or were using products that just didn’t work for them. So, we designed this class with YOU in mind — whether you’ve never picked up a brush, or just want to polish your skills like a pro.</p>

          <h3>✨ What You’ll Experience in Our Self-Makeup Session:</h3>
          <ul>
            <li>🧠 No-fluff makeup theory — super simple, super fun, zero confusion!</li>
            <li>💼 Dive into your makeup stash – we’ll help you use what you already have!</li>
            <li>✨ Live demo – watch step by step application from prep to finish</li>
            <li>🧴 Skincare prep – happy skin = flawless makeup</li>
            <li>💄 Hands-on practice under my guidance</li>
            <li>🔍 Personal attention — guided corrections and support</li>
            <li>🪞 A judgment-free, fun zone with real learning</li>
          </ul>

          <h3>🌟 What Makes This Class Special:</h3>
          <ul>
            <li>📌 Learn my signature “UNIVERSAL LOOK” for any occasion</li>
            <li>📌 Real product knowledge and customized kit suggestions</li>
            <li>📌 Skincare tips tailored to you</li>
            <li>📌 Confidence to glam yourself up anytime</li>
          </ul>

          <h3>👜 What to Bring:</h3>
          <ul>
            <li>Your skincare and makeup products</li>
            <li>A big smile and excitement!</li>
          </ul>

          <h3>🧭 Class Flow:</h3>
          <ul>
            <li>Product review & analysis</li>
            <li>Theory + live demo</li>
            <li>Practice with full product access</li>
            <li>Q&A time</li>
          </ul>

          <p>This class isn’t about perfection — it’s about feeling empowered, playful, and beautifully YOU.
            <br />Can’t wait to see you there, brush in hand and heart open! 💖 For more details, <a href="mailto:team@atelierbyshriji.in">get in touch</a>.</p>

          <p><strong>NOTE:</strong> We also take workshops on a big scale like parties and events. For more info, <a href="mailto:team@atelierbyshriji.in">contact us</a>.</p>
        </div>
      )}

      <div>
      <Testimonial1 />
    </div>
    </div>
    
  );
};

export default SelfMakeup;